/**
 * iOS launch: TurboModule + Hermes races around ~200–600ms caused SIGABRT on TestFlight.
 * Require a minimum quiet period, then stagger analytics SDKs so void-method invocations
 * do not run concurrently (see convertNSExceptionToJSError + Hermes GCScope crashes).
 */

/**
 * Minimum ms after launch before TurboModule-heavy init (iOS).
 * TestFlight SIGSEGV clustered around 200–600ms; full-app gate removed — keep a short quiet window only.
 */
export const NATIVE_SDK_BRIDGE_MIN_MS = 600;

/** Delay after bridge ready before the analytics phase opens. */
export const NATIVE_SDK_ANALYTICS_STAGGER_MS = 600;

/** Extra delay after analytics gate before mounting PostHog. */
export const NATIVE_SDK_POSTHOG_STAGGER_MS = 300;

/** Extra delay after PostHog gate before Mixpanel.init. */
export const NATIVE_SDK_MIXPANEL_STAGGER_MS = 500;

/** Extra delay after analytics gate before Sentry.init. */
export const NATIVE_SDK_CRASH_REPORTING_STAGGER_MS = 500;

/**
 * iOS launch-crash bisect: disable suspects one at a time on native.
 * Flip to true to skip a SDK without removing code paths.
 *
 * 1.0.51: Sentry, PostHog and Mixpanel intentionally re-enabled for iOS parity with
 * Android (launch stabilized behind the staggered-init window above). Each flag stays
 * independently toggleable so a launch regression can be re-bisected without code changes.
 */
export const IOS_DISABLED_NATIVE_SDKS = {
  SENTRY: false,
  POSTHOG: false,
  MIXPANEL: false,
  /** No iOS IAP key / products yet — keep Purchases.configure skipped on iOS. */
  REVENUECAT: true,
} as const;
